import { func, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomDropdown from '@components/CustomDropdown';
import ModalContainer from '@components/modals/ModalContainer';

import { CloseButton, ModalHeader, ModalTitle } from '@features/trend-research/components/common/Modal';
import { useAddMoodBoardMutation } from '@features/trend-research/api/moodboardApi';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchBrandBasicList } from '@services/commonService';
import { updateTrendBoardById } from '@services/trendResearch';

const CreateOrUpdateMoodboard = ({ onClose, callBack, title, type, moodBoardInfo }) => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const [name, setName] = useState('');
	const [errors, setErrors] = useState({});
	const [brands, setBrands] = useState([]);
	const [selectedBrand, setSelectedBrand] = useState({});
	const [addMoodBoard] = useAddMoodBoardMutation();

	useEffect(() => {
		if (type === 'UPDATE') {
			(async () => {
				try {
					dispatch(openLoader());
					const data = await fetchBrandBasicList();
					let brandList = data?.map((item) => ({ id: item.id, value: item.name }));
					setBrands(brandList);
					setSelectedBrand(brandList.find((item) => item.id === moodBoardInfo.brandId));
					setName(moodBoardInfo?.name);
					dispatch(closeLoader());
				} catch {
					dispatch(closeLoader());
				}
			})();
		}
	}, [type]);

	const saveMoodBoard = async () => {
		try {
			dispatch(openLoader());
			let postData = { name };
			if (selectedBrand?.id) {
				postData.brandId = selectedBrand.id;
			}
			if (type === 'CREATE') await addMoodBoard(postData).unwrap();
			if (type === 'UPDATE') await updateTrendBoardById(id, postData);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const handleSubmit = async () => {
		if (name) {
			setErrors({});
			await saveMoodBoard();
			await callBack();
			onClose();
		} else {
			setErrors({
				name: 'Name is required!'
			});
		}
	};

	const onItemClick = (obj) => {
		setSelectedBrand(obj);
	};

	return (
		<ModalContainer onCloseModal={onClose} className="add-section-popup">
			<div className="common-popup add-section-popup">
				<ModalHeader>
					<ModalTitle title={title} />
					<CloseButton onClick={onClose} />
				</ModalHeader>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Mood Board Name</label>
								<input
									type="text"
									className="w-100"
									value={name}
									onChange={(e) => setName(e.target.value)}
								/>
								{errors?.name && <p className="error">{errors.name}</p>}
							</div>
						</div>
						{type === 'UPDATE' && (
							<div className="col-md-12 pr-2">
								<div className="form-group">
									<label htmlFor="collection">Brand</label>
									<CustomDropdown
										type="addItem"
										title={''}
										isShowLabel={false}
										onItemClick={onItemClick}
										items={brands}
										selectedItem={selectedBrand?.value || ''}
									/>
								</div>
							</div>
						)}
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button size32 outline" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={handleSubmit}>
							Create
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

CreateOrUpdateMoodboard.propTypes = {
	onClose: func.isRequired,
	callBack: func.isRequired,
	title: string.isRequired,
	type: string.isRequired
};

export default CreateOrUpdateMoodboard;
